import { useEffect, useState } from 'react';
import { useHrpsApi } from '../clients/useHrpsApi';
import { PURCHASE_ORDER_SOURCE_DOCUMENT_TYPE } from '../constants';
import { AttachedDocument } from '../redux/types';

/**
 * Finds the document a purchase order was extracted from. Orders entered any other way have none.
 */
export const usePurchaseOrderSourceDocument = (resellerId: string | undefined, purchaseOrderId: string) => {
    const {
        returnOrders: { getSalesOrderDocuments },
    } = useHrpsApi();
    const [sourceDocument, setSourceDocument] = useState<AttachedDocument | undefined>(undefined);

    useEffect(() => {
        let isCurrent = true;
        setSourceDocument(undefined);

        if (resellerId && purchaseOrderId) {
            getSalesOrderDocuments(resellerId, purchaseOrderId)
                .then((documents) => {
                    if (isCurrent) {
                        setSourceDocument(
                            documents.find((document) => document.type === PURCHASE_ORDER_SOURCE_DOCUMENT_TYPE)
                        );
                    }
                })
                .catch(() => {
                    // Without the document there is nothing to download, which the page already shows.
                });
        }
        return () => {
            isCurrent = false;
        };
    }, [getSalesOrderDocuments, resellerId, purchaseOrderId]);

    return sourceDocument;
};
